import { render, staticRenderFns } from "./PaymentRequest.vue?vue&type=template&id=68efe84b&scoped=true&"
import script from "./PaymentRequest.vue?vue&type=script&lang=js&"
export * from "./PaymentRequest.vue?vue&type=script&lang=js&"
import style1 from "./PaymentRequest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68efe84b",
  null
  
)

export default component.exports